export default __webpack_public_path__ + "347da211f4dc453d704d010fd161568c.png";